import { npcPortrait, type NpcId, type PortId } from '@/lib/assets';

export interface NpcMeta {
  id: NpcId;
  name: string;
  title: string;
  portrait: string;
  homePort: PortId;
  tutorialQuest: number;
}

export const NPCS: Record<NpcId, NpcMeta> = {
  old_pete: {
    id: 'old_pete',
    name: 'Old Pete',
    title: 'Grizzled Mentor',
    portrait: npcPortrait('old_pete'),
    homePort: 'tortuga',
    tutorialQuest: 1,
  },
  mistress_vela: {
    id: 'mistress_vela',
    name: 'Mistress Vela',
    title: 'Tavern Owner',
    portrait: npcPortrait('mistress_vela'),
    homePort: 'port_royale',
    tutorialQuest: 2,
  },
  drillmaster_bartolo: {
    id: 'drillmaster_bartolo',
    name: 'Drillmaster Bartolo',
    title: 'Ex-Navy Instructor',
    portrait: npcPortrait('drillmaster_bartolo'),
    homePort: 'charleston',
    tutorialQuest: 3,
  },
  sneaky_jim: {
    id: 'sneaky_jim',
    name: 'Sneaky Jim',
    title: 'Thief & Informant',
    portrait: npcPortrait('sneaky_jim'),
    homePort: 'tortuga',
    tutorialQuest: 4,
  },
  quartermaster_hale: {
    id: 'quartermaster_hale',
    name: 'Quartermaster Hale',
    title: 'Gruff Vendor',
    portrait: npcPortrait('quartermaster_hale'),
    homePort: 'port_royale',
    tutorialQuest: 5,
  },
  shipwright_mara: {
    id: 'shipwright_mara',
    name: 'Shipwright Mara',
    title: 'Master Craftsman',
    portrait: npcPortrait('shipwright_mara'),
    homePort: 'maracaibo',
    tutorialQuest: 6,
  },
  harbormaster_finn: {
    id: 'harbormaster_finn',
    name: 'Harbormaster Finn',
    title: 'Keeper of the Logs',
    portrait: npcPortrait('harbormaster_finn'),
    homePort: 'nassau',
    tutorialQuest: 9,
  },
};

export function getNpc(id: string): NpcMeta | undefined {
  return NPCS[id as NpcId];
}
